import * as Immutable from "immutable";
import moment from "moment";
import trim from "lodash/trim";
function parseNow(now) {
  if (now === void 0 || now === null || trim(now) === "") {
    return void 0;
  }
  return moment(now);
}
export default class GlobalOverride {
  constructor(timerange, query, keepSearchTypes, searchTypes, keepQueries, now) {
    this._value = { timerange, query, keepSearchTypes, searchTypes, keepQueries, now };
  }
  get timerange() {
    return this._value.timerange;
  }
  get query() {
    return this._value.query;
  }
  get keepSearchTypes() {
    return this._value.keepSearchTypes;
  }
  get keepQueries() {
    return this._value.keepQueries;
  }
  get searchTypes() {
    return this._value.searchTypes;
  }
  get now() {
    return this._value.now;
  }
  toBuilder() {
    const { timerange, query, keepSearchTypes, searchTypes, keepQueries, now } = this._value;
    return new Builder(Immutable.Map({ timerange, query, keepSearchTypes, searchTypes, keepQueries, now }));
  }
  static create(timerange, query, keepSearchTypes, searchTypes, keepQueries, now) {
    return new GlobalOverride(timerange, query, keepSearchTypes, searchTypes, keepQueries, now);
  }
  static empty() {
    return new GlobalOverride();
  }
  static builder() {
    return new Builder();
  }
  toJSON() {
    const { timerange, query, keepSearchTypes, keepQueries, searchTypes, now } = this._value;
    return {
      timerange,
      query,
      keep_search_types: keepSearchTypes,
      keep_queries: keepQueries,
      search_types: searchTypes,
      now: now == null ? void 0 : now.toISOString()
    };
  }
  static fromJSON(value) {
    const { timerange, query, keep_search_types, search_types, keep_queries, now } = value;
    return GlobalOverride.create(timerange, query, keep_search_types, search_types, keep_queries, parseNow(now));
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  timerange(timerange) {
    return new Builder(this.value.set("timerange", timerange));
  }
  query(query) {
    return new Builder(this.value.set("query", query));
  }
  keepSearchTypes(keepSearchTypes) {
    return new Builder(this.value.set("keepSearchTypes", keepSearchTypes));
  }
  keepQueries(keepQueries) {
    return new Builder(this.value.set("keepQueries", keepQueries));
  }
  searchTypes(searchTypes) {
    return new Builder(this.value.set("searchTypes", searchTypes));
  }
  now(now) {
    return new Builder(this.value.set("now", now));
  }
  build() {
    const { timerange, query, keepSearchTypes, searchTypes, keepQueries, now } = this.value.toObject();
    return new GlobalOverride(timerange, query, keepSearchTypes, searchTypes, keepQueries, now);
  }
}
